import React, { Component } from 'react'
import moment from 'moment'
import Select from 'react-select'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { portFetchAll } from 'actions/portAction'
import { AvForm } from 'availity-reactstrap-validation'
import { operatorFetchPage } from 'actions/operatorAction'
import { sisaQuotaTrayek } from '../../actions/dashboardAction'
import { msttrayekFetchAll } from '../../actions/msttrayekAction'
import { Row, Col, Card, CardHeader, CardBody, CardFooter, Button, FormGroup, Table, Pagination, PaginationItem, PaginationLink, Collapse } from 'reactstrap'

let isDefaultMonth = false
let isDefaultTrayek = false
let isDefaultOperator = false
let isDefaultPortOrigin = false
let isDefaultPortDestination = false
let thisMonth = moment().format('M')
let month_option = [
  { value: 1, label: 'Januari' },
  { value: 2, label: 'Februari' },
  { value: 3, label: 'Maret' },
  { value: 4, label: 'April' },
  { value: 5, label: 'Mei' },
  { value: 6, label: 'Juni' },
  { value: 7, label: 'Juli' },
  { value: 8, label: 'Agustus' },
  { value: 9, label: 'September' },
  { value: 10, label: 'Oktober' },
  { value: 11, label: 'November' },
  { value: 12, label: 'Desember' }
]

class SisaQuotaTrayek extends Component {
  constructor(props) {
    super(props)
    this.state = {
      start: 0,
      curPage: 1,
      perPage: 10,
      month: '',
      month_label: '',
      trayek_id: '',
      trayek_label: '',
      operator_id: '',
      operator_label: '',
      port_origin_id: '',
      port_origin_label: '',
      port_destination_id: '',
      port_destination_label: ''
    }

    this.selectMonth = this.selectMonth.bind(this)
    this.selectTrayek = this.selectTrayek.bind(this)
    this.selectOperator = this.selectOperator.bind(this)
    this.selectPortOrigin = this.selectPortOrigin.bind(this)
    this.selectPortDestination = this.selectPortDestination.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleFilter = this.handleFilter.bind(this)
  }

  componentDidMount() {
    let data = {
      length: 10,
      month: thisMonth
    }

    this.props.sisaQuotaTrayek(data)
    this.props.msttrayekFetchAll()
    this.props.operatorFetchPage()
    this.props.portFetchAll()
  }

  componentWillUnmount() {
    isDefaultMonth = false
    isDefaultTrayek = false
    isDefaultOperator = false
    isDefaultPortOrigin = false
    isDefaultPortDestination = false
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.curPage !== this.state.curPage) {
      const data = {
        length: this.state.perPage,
        trayek_id: this.state.trayek_id,
        operator_id: this.state.operator_id,
        port_origin_id: this.state.port_origin_id,
        port_destination_id: this.state.port_destination_id
      }

      if (this.state.month) {
        data.month = this.state.month
      } else {
        data.month = thisMonth
      }

      if (this.state.curPage === undefined) {
        data.start = this.state.start
      } else {
        let offset = (this.state.curPage * 10) - 10
        data.start = offset
      }

      this.props.sisaQuotaTrayek(data)
    }
  }

  changeRupiah(bilangan) {
    var number_string = bilangan.toString(),
      sisa = number_string.length % 3,
      rupiah = number_string.substr(0, sisa),
      ribuan = number_string.substr(sisa).match(/\d{3}/g);

    if (ribuan) {
      let separator = sisa ? '.' : '';
      rupiah += separator + ribuan.join('.');
    }

    return rupiah
  }

  selectMonth(opt) {
    if (opt) {
      this.setState({
        month: opt.value,
        month_label: opt.label
      })
    } else {
      this.setState({
        month: '',
        month_label: ''
      })
    }
  }

  selectTrayek(opt) {
    if (opt) {
      this.setState({
        trayek_id: opt.value,
        trayek_label: opt.label
      })
    } else {
      this.setState({
        trayek_id: '',
        trayek_label: ''
      })
    }
  }

  selectOperator(opt) {
    if (opt) {
      this.setState({
        operator_id: opt.value,
        operator_label: opt.label
      })
    } else {
      this.setState({
        operator_id: '',
        operator_label: ''
      })
    }
  }

  selectPortOrigin(opt) {
    if (opt) {
      this.setState({
        port_origin_id: opt.value,
        port_origin_label: opt.label
      })
    } else {
      this.setState({
        port_origin_id: '',
        port_origin_label: ''
      })
    }
  }

  selectPortDestination(opt) {
    if (opt) {
      this.setState({
        port_destination_id: opt.value,
        port_destination_label: opt.label
      })
    } else {
      this.setState({
        port_destination_id: '',
        port_destination_label: ''
      })
    }
  }

  handleClick(e) {
    this.setState({ curPage: e })
  }

  handleFilter(event, values) {
    if (this.state.month) {
      values.month = this.state.month
      isDefaultMonth = true
    } else {
      values.month = thisMonth
      isDefaultMonth = false
    }

    if (this.state.trayek_id) {
      values.trayek_id = this.state.trayek_id
      isDefaultTrayek = true
    } else {
      delete values.trayek_id
      isDefaultTrayek = false
    }

    if (this.state.operator_id) {
      values.operator_id = this.state.operator_id
      isDefaultOperator = true
    } else {
      delete values.operator_id
      isDefaultOperator = false
    }

    if (this.state.port_origin_id) {
      values.port_origin_id = this.state.port_origin_id
      isDefaultPortOrigin = true
    } else {
      delete values.port_origin_id
      isDefaultPortOrigin = false
    }

    if (this.state.port_destination_id) {
      values.port_destination_id = this.state.port_destination_id
      isDefaultPortDestination = true
    } else {
      delete values.port_destination_id
      isDefaultPortDestination = false
    }

    values.length = this.state.perPage

    this.props.sisaQuotaTrayek(values)
  }

  renderData() {
    if (this.props.sisaQuotaTrayekIsSuccess) {
      let defaultValues = {
        month: this.state.month,
        month_label: this.state.month_label,
        trayek_id: this.state.trayek_id,
        trayek_label: this.state.trayek_label,
        operator_id: this.state.operator_id,
        operator_label: this.state.operator_label,
        port_origin_id: this.state.port_origin_id,
        port_origin_label: this.state.port_origin_label,
        port_destination_id: this.state.port_destination_id,
        port_destination_label: this.state.port_destination_label,
      }

      const prevPage = parseInt(this.props.sisaQuotaTrayekData.currentPage) - 1
      const nextPage = parseInt(this.props.sisaQuotaTrayekData.currentPage) + 1

      let curPage = this.props.sisaQuotaTrayekData.currentPage
      let minPage = Number(curPage) - 2
      let maxPage = Number(curPage) + 2

      const pages = []
      const totalPages = this.props.sisaQuotaTrayekData.pageTotal

      for (let index = 1; index <= totalPages; index++) {
        if (pages.indexOf(index) == -1) {
          pages.push(index)
        }
      }

      const { month } = this.state.month
      const { trayek_id } = this.state.trayek_id
      const { operator_id } = this.state.operator_id
      const { port_origin_id } = this.state.port_origin_id
      const { port_destination_id } = this.state.port_destination_id
      const defaultValueMonth = { label: defaultValues.month_label, value: defaultValues.month }
      const defaultValueTrayek = { label: defaultValues.trayek_label, value: defaultValues.trayek_id }
      const defaultValueOperator = { label: defaultValues.operator_label, value: defaultValues.operator_id }
      const defaultValuePortOrigin = { label: defaultValues.port_origin_label, value: defaultValues.port_origin_id }
      const defaultValuePortDestination = { label: defaultValues.port_destination_label, value: defaultValues.port_destination_id }

      return (
        <div>
          <Card>
            <CardHeader>
              <h5>Daftar sisa kuota trayek</h5>
              <hr />
              <AvForm onValidSubmit={this.handleFilter} model={defaultValues}>
                <Row>
                  {this.props.trayekIsSuccess &&
                    <Col md="4">
                      <FormGroup>
                        <Select name="trayek_id"
                          value={trayek_id}
                          isClearable
                          placeholder="Trayek..."
                          defaultValue={isDefaultTrayek ? defaultValueTrayek : false}
                          onChange={this.selectTrayek}
                          options={this.props.msttrayeks.data}
                          id="trayek_id"
                          inputId="input_trayek_id"
                          instanceId="instance_trayek_id"
                        />
                      </FormGroup>
                    </Col>
                  }
                  <Col md="4">
                    <FormGroup>
                      <Select name="month"
                        value={month}
                        isClearable
                        placeholder="Bulan..."
                        defaultValue={isDefaultMonth ? defaultValueMonth : false}
                        onChange={this.selectMonth}
                        options={month_option}
                        id="month"
                        inputId="input_month"
                        instanceId="instance_month"
                      />
                    </FormGroup>
                  </Col>
                  {this.props.operatorIsSuccess &&
                    <Col md="4">
                      <FormGroup>
                        <Select name="operator_id"
                          value={operator_id}
                          isClearable
                          placeholder="Operator..."
                          defaultValue={isDefaultOperator ? defaultValueOperator : false}
                          onChange={this.selectOperator}
                          options={this.props.operators.options}
                          id="operator_id"
                          inputId="input_operator_id"
                          instanceId="instance_operator_id"
                        />
                      </FormGroup>
                    </Col>
                  }
                </Row>
                <Row>
                  {this.props.portIsSuccess &&
                    <Col md="4">
                      <FormGroup>
                        <Select name="port_origin_id"
                          value={port_origin_id}
                          isClearable
                          placeholder="Pelabuhan asal..."
                          defaultValue={isDefaultPortOrigin ? defaultValuePortOrigin : false}
                          onChange={this.selectPortOrigin}
                          options={this.props.ports.data}
                          id="port_origin_id"
                          inputId="input_port_origin_id"
                          instanceId="instance_port_origin_id" />
                      </FormGroup>
                    </Col>
                  }
                  {this.props.portIsSuccess &&
                    <Col md="4">
                      <FormGroup>
                        <Select name="port_destinaton_id"
                          value={port_destination_id}
                          isClearable
                          placeholder="Pelabuhan tujuan..."
                          defaultValue={isDefaultPortDestination ? defaultValuePortDestination : false}
                          onChange={this.selectPortDestination}
                          options={this.props.ports.data}
                          id="port_destinaton_id"
                          inputId="input_port_destinaton_id"
                          instanceId="instance_port_destinaton_id" />
                      </FormGroup>
                    </Col>
                  }
                  <Col md="4">
                    <FormGroup className="form-actions">
                      <Button type="submit" size="md" color="primary" className=" btn-brand mr-1 mb-1">
                        <i className="fa fa-search"></i> <span>Proses </span>
                      </Button>
                    </FormGroup>
                  </Col>
                </Row>
              </AvForm>
            </CardHeader>
            <CardBody className="p-0">
              <Table responsive striped>
                <thead>
                  <tr>
                    <th>Operator</th>
                    <th>Trayek</th>
                    <th>Jenis Container</th>
                    <th>Alokasi Kuota</th>
                    <th>Sisa Kuota</th>
                    <th>Pelabuhan Asal</th>
                    <th>Pelabuhan Tujuan</th>
                    <th>ETD </th>
                    <th>ETA </th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.sisaQuotaTrayekData.data.map((item, key) => (
                    <tr key={key}>
                      <td>{item.operator}</td>
                      <td><strong>{item.kode_trayek}</strong><br /> {item.voyage && 'Voyage ' + item.voyage}</td>
                      <td>{item.type_container_name}</td>
                      <td>{item.total_alokasi_quota && this.changeRupiah(item.total_alokasi_quota)}</td>
                      <td>{item.total_sisa && this.changeRupiah(item.total_sisa)}</td>
                      <td>{item.pelabuhan_asal}</td>
                      <td>{item.pelabuhan_tujuan}</td>
                      <td>{item.etd && moment(item.etd).format('DD MMMM YYYY')}</td>
                      <td>{item.eta && moment(item.eta).format('DD MMMM YYYY')}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </CardBody>
            <CardFooter>
              <Pagination>
                {this.props.sisaQuotaTrayekData.hasPrev ?
                  <PaginationItem>
                    <PaginationLink previous tag="button" onClick={(e) => this.handleClick(1)}>
                      First Page
                </PaginationLink>
                  </PaginationItem>
                  : null
                }

                {this.props.sisaQuotaTrayekData.hasPrev ?
                  <PaginationItem>
                    <PaginationLink previous tag="button" onClick={(e) => this.handleClick(prevPage)}>
                      Prev
                </PaginationLink>
                  </PaginationItem>
                  : null
                }

                {pages.map((item, index) => {
                  let actived = false
                  if (curPage === undefined) {
                    curPage = 1
                  }

                  if (item == curPage) {
                    actived = true
                  }

                  if (item >= minPage && item <= maxPage) {
                    return <PaginationItem active={actived} key={index}>
                      <PaginationLink tag="button" onClick={(e) => this.handleClick(item)}>
                        {item}
                      </PaginationLink>
                    </PaginationItem>
                  }
                })}

                {this.props.sisaQuotaTrayekData.hasNext ?
                  <PaginationItem>
                    <PaginationLink next tag="button" onClick={(e) => this.handleClick(nextPage)}>
                      Next
                </PaginationLink>
                  </PaginationItem>
                  : null
                }

                {this.props.sisaQuotaTrayekData.hasNext ?
                  <PaginationItem>
                    <PaginationLink next tag="button" onClick={(e) => this.handleClick(totalPages)}>
                      Last Page
                </PaginationLink>
                  </PaginationItem>
                  : null
                }
              </Pagination>

              {this.props.sisaQuotaTrayekData.pageTotal > 0 &&
                <p>Page: {this.props.sisaQuotaTrayekData.currentPage} of {this.props.sisaQuotaTrayekData.pageTotal}</p>
              }
            </CardFooter>
          </Card>
        </div>
      )
    }
  }

  render() {
    if (this.props.sisaQuotaTrayekIsLoading) {
      return (
        <div>
          <p>Loading ..... </p>
        </div>
      )
    }

    if (this.props.sisaQuotaTrayekHasError) {
      return (
        <div>
          <p>Silahkan mencoba beberapa saat lagi, pastikan anda terkoneksi dengan internet</p>
        </div>
      )
    }

    return (
      <div>
        {this.renderData()}
      </div>
    )
  }
}

SisaQuotaTrayek.propTypes = {
  sisaQuotaTrayekIsSuccess: PropTypes.bool.isRequired,
  sisaQuotaTrayekHasError: PropTypes.bool.isRequired,
  sisaQuotaTrayekIsLoading: PropTypes.bool.isRequired,

  operatorIsSuccess: PropTypes.bool.isRequired,
  operatorHasError: PropTypes.bool.isRequired,
  operatorIsLoading: PropTypes.bool.isRequired
}

const mapStateToProps = (state) => {
  return {
    sisaQuotaTrayekData: state.dashboard.sisaQuotaTrayekData,
    sisaQuotaTrayekIsSuccess: state.dashboard.sisaQuotaTrayekSuccess,
    sisaQuotaTrayekHasError: state.dashboard.sisaQuotaTrayekError,
    sisaQuotaTrayekIsLoading: state.dashboard.sisaQuotaTrayekLoading,

    msttrayeks: state.msttrayeks.msttrayeks,
    trayekHasError: state.msttrayeks.msttrayekGetError,
    trayekIsSuccess: state.msttrayeks.msttrayekGetSuccess,
    trayekIsLoading: state.msttrayeks.msttrayekGetLoading,

    operators: state.operators.operators,
    operatorIsSuccess: state.operators.operatorGetSuccess,
    operatorHasError: state.operators.operatorGetError,
    operatorIsLoading: state.operators.operatorGetLoading,

    ports: state.ports.ports,
    portHasError: state.ports.portGetError,
    portIsSuccess: state.ports.portGetSuccess,
    portIsLoading: state.ports.portGetLoading
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    sisaQuotaTrayek: (data) => dispatch(sisaQuotaTrayek(data)),
    msttrayekFetchAll: () => dispatch(msttrayekFetchAll()),
    operatorFetchPage: (data) => dispatch(operatorFetchPage(data)),
    portFetchAll: () => dispatch(portFetchAll())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SisaQuotaTrayek)